import {
  ChangeDetectionStrategy,
  Component,
  computed,
  inject,
  input,
  output,
} from "@angular/core";
import { SideDrawerComponent } from "../shell/side-drawer.component";
import {
  CrewCommandsStore,
  SHORE_LABELS,
} from "../core/sim/crew-commands.store";

/**
 * Single-sailor shore panel — controls the one crew member who can
 * leave the boat (skok na pomost / powrót na pokład) so they can
 * receive thrown lines and tie them to bollards. Previously bundled
 * into the mooring drawer; now lives behind its own icon for
 * clarity.
 */
@Component({
  selector: "po-crew-drawer",
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SideDrawerComponent],
  templateUrl: "./crew-drawer.component.html",
  styleUrl: "./crew-drawer.component.css",
})
export class CrewDrawerComponent {
  readonly open = input.required<boolean>();
  readonly anchorBottom = input<number>(64);
  readonly closeRequest = output<void>();

  readonly store = inject(CrewCommandsStore);
  readonly shore = computed(() => this.store.shore());
  readonly nearShore = computed(() => this.store.playerNearShore());
  readonly stranded = computed(() => this.store.sailorStranded());

  shoreLabel(s: keyof typeof SHORE_LABELS): string {
    return SHORE_LABELS[s];
  }
}
